function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProgress = function SvgProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    clipRule: "evenodd",
    viewBox: "-1 -1 34 34"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M31.169 16a15.17 15.17 0 0 1-9.364 14.014 15.17 15.17 0 0 1-16.53-3.288 15.17 15.17 0 0 1-3.29-16.531A15.17 15.17 0 0 1 16 .83V16zm0 0a15.17 15.17 0 0 1-15.17 15.169A15.17 15.17 0 0 1 .832 15.999 15.17 15.17 0 0 1 16 .832 15.17 15.17 0 0 1 31.169 16z",
    style: {
      paintOrder: "stroke markers fill"
    }
  }));
};
export default SvgProgress;